import React from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  replace,
  Navigate,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import SidebarMenu from "./component/SidebarMenu";
import Home from "./screen/Home";
import Quatation from "./screen/Quatation";
import Project from "./screen/Project";
import Expenses from "./screen/Expenses";
import Setting from "./screen/Setting";
import Invoice from "./screen/Invoice";
import QuotationCom from "./component/subRouterScreen/quotationScr/QuotationCom";
import ProformaInvoice from "./component/subRouterScreen/InvoiveScr/ProformaInvoice";
import AddInvoice from "./component/subRouterScreen/InvoiveScr/AddInvoice";
import InvoiceCom from "./component/subRouterScreen/InvoiveScr/InvoiceCom";
import QuotationAdd from "./component/subRouterScreen/quotationScr/QuotationAdd";
import ProjectView from "./component/subRouterScreen/projectScr.js/ProjectView";
import ProjectAdd from "./component/subRouterScreen/projectScr.js/ProjectAdd";
import ExpensesView from "./component/subRouterScreen/expensesScr/ExpensesView";
import ExpensesAdd from "./component/subRouterScreen/expensesScr/ExpensesAdd";
import Category from "./component/subRouterScreen/settingScr/Category";
import Profile from "./component/subRouterScreen/settingScr/Profile";
import Branch from "./component/subRouterScreen/settingScr/Branch";
import ProformaInvoiceCom from "./component/subRouterScreen/InvoiveScr/ProformaInvoiceCom";
import { QueryClient, QueryClientProvider } from "react-query";
import CategoryCom from "./component/subRouterScreen/settingScr/CategoryCom";
import BranchCom from "./component/subRouterScreen/settingScr/BranchCom";
import HomeCom from "./component/subRouterScreen/home/HomeCom";
import QuotationInvoice from "./component/subRouterScreen/quotationScr/QuotationInvoice";
import Login from "./screen/Login";
import ProformaInvoiceBill from "../src/component/subRouterScreen/InvoiveScr/ProformaInvoiceBill";
import InvoiceBill from "./component/subRouterScreen/InvoiveScr/InvoiceBill";

export default function Navigation() {
  const location = useLocation();
  const queryClient = new QueryClient();

  const logintrue = sessionStorage.getItem("login");
  return (
    <>
      {location.pathname !== "/" && logintrue && (
        <div style={{ width: "100px" }}>
          <SidebarMenu />
        </div>
      )}
      <div style={{ width: "100%" }}>
        {logintrue ? (
          <>
            <Routes>
              <Route path="/" element={<Home />}>
                <Route index element={<Navigate to="homeCom" replace />} />
                <Route path="/homeCom" element={<HomeCom />}></Route>
              </Route>

              <Route path="/invoice" element={<Invoice />}>
                <Route index element={<Navigate to="invoicePage" replace />} />
                <Route path="invoicePage" element={<InvoiceCom />} />
                <Route
                  path="ProformaInvoiceView"
                  element={<ProformaInvoiceCom />}
                />
                <Route path="ProformaInvoice" element={<ProformaInvoice />} />
                <Route
                  path="proformaInvoiceBill"
                  element={<ProformaInvoiceBill />}
                />
                <Route path="addInvoice" element={<AddInvoice />} />

                <Route path="invoiceBill" element={<InvoiceBill />} />
              </Route>

              <Route path="/quatation" element={<Quatation />}>
                <Route
                  index
                  element={<Navigate to="quotationView" replace />}
                />
                <Route path="quotationAdd" element={<QuotationAdd />} />{" "}
                <Route path="quotationView" element={<QuotationCom />} />{" "}
                <Route path="quotationInvoice" element={<QuotationInvoice />} />
              </Route>

              <Route path="/project" element={<Project />}>
                <Route index element={<Navigate to="projectView" replace />} />
                <Route path="projectView" element={<ProjectView />} />
                <Route path="projectAdd" element={<ProjectAdd />} />
              </Route>

              <Route path="/expenses" element={<Expenses />}>
                <Route index element={<Navigate to="expensesView" replace />} />
                <Route path="expensesView" element={<ExpensesView />} />
                <Route path="expensesAdd" element={<ExpensesAdd />} />
              </Route>

              <Route path="/setting" element={<Setting />}>
                <Route index element={<Navigate to="categoryView" replace />} />
                <Route path="category" element={<Category />} />
                <Route path="categoryView" element={<CategoryCom />} />
                <Route path="profile" element={<Profile />} />
                <Route path="branch" element={<Branch />} />
                <Route path="branchView" element={<BranchCom />} />
              </Route>
            </Routes>
          </>
        ) : (
          <>
            <Routes>
              <Route path="/" element={<Login />} />
            </Routes>
          </>
        )}
      </div>
    </>
  );
}
